import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/pro-solid-svg-icons'
import { useAccordionButton } from 'react-bootstrap/AccordionButton'
import { constVoid } from '@packages/prelude'
import { AccordionContext, FormCheck } from 'react-bootstrap'
import { IconDefinition } from '@fortawesome/free-brands-svg-icons'
import { ControlButton } from './ControlButton'

interface Props {
  eventKey: string
  iconActive?: IconDefinition
  iconInactive?: IconDefinition
}

export const AccordionToggleButton: React.FC<Props> = ({ eventKey, iconActive = faChevronUp, iconInactive = faChevronDown }) => {
  const onClick = useAccordionButton(eventKey, constVoid)
  const { activeEventKey } = React.useContext(AccordionContext)

  const isOpen = activeEventKey === eventKey
  return (
    <ControlButton onClick={onClick}>
      <FontAwesomeIcon icon={isOpen ? iconActive : iconInactive} color={isOpen ? 'var(--primary-light)' : ''} />
    </ControlButton>
  )
}

interface SwitchProps {
  eventKey: string
  onToggle: () => void
  selected: boolean
}

const Switch: React.FC<SwitchProps> = ({ eventKey, onToggle, selected }) => {
  const onClick = useAccordionButton(eventKey, onToggle)

  return <FormCheck type="switch" id="custom-switch" label="" aria-expanded={selected} onChange={onClick} />
}

export default Object.assign(AccordionToggleButton, {
  Switch
})
